import {EmployeeRef, EntityType, Neighbourhood, NeighbourhoodForm} from "./Model";
import {EntityStore, startEntityStore} from "./resourceStoreBuilder";
import {create} from "zustand";
import Subscription from "../util/Subscription";
import {officeArrayResource} from "./CurrentOfficeStore";
import {replaceElement} from "../util/ArrayUtil";
import {Neighbourhoods_Read} from "../util/access/Permission";

interface NeighbourhoodStore extends EntityStore<Neighbourhood[]> {
    updateNeighbourhood: (neighbourhood: Neighbourhood, form: NeighbourhoodForm) => Promise<Neighbourhood>,
    addEmployee: (neighbourhood: Neighbourhood, employee: EmployeeRef) => Promise<void>,
    removeEmployee: (neighbourhood: Neighbourhood, employee: EmployeeRef) => Promise<void>,
}

export const neighbourhoodSubscription = new Subscription();

export const useNeighbourhoodStore = create<NeighbourhoodStore>()(
    officeArrayResource<Neighbourhood, NeighbourhoodStore>(EntityType.Neighbourhoods, builder => {
        const rest = builder.crud('/neighbourhoods', 'id');
        const employeeRest = rest.subresource<EmployeeRef, EmployeeRef>('/employees', 'id');

        return {
            remoteValue: builder.all(Neighbourhoods_Read, () => rest.getAll()),
            updateNeighbourhood: builder.updateAndPatch<NeighbourhoodForm>(rest, neighbourhoodSubscription),
            addEmployee: async (neighbourhood, employee) => {
                await employeeRest(neighbourhood).create(employee);
                const updated = {...neighbourhood, employees: [...neighbourhood.employees.filter(e => e.id !== employee.id), employee]};
                builder.patch(prev => replaceElement(prev, n => n === neighbourhood, updated));
                neighbourhoodSubscription.notify();
            },
            removeEmployee: async (neighbourhood, employee) => {
                await employeeRest(neighbourhood).delete(employee);
                const updated = {...neighbourhood, employees: neighbourhood.employees.filter(e => e.id !== employee.id)};
                builder.patch(prev => replaceElement(prev, n => n === neighbourhood, updated));
                neighbourhoodSubscription.notify();
            },
        };
    })
);

startEntityStore(useNeighbourhoodStore);
